import { CalculationSchema } from "src/features/calculator/schema"

function toQueryParams(obj: Record<string, any>, prefix = ""): string {
  const params = Object.entries(obj).flatMap(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === "object" && value !== null) {
      return toQueryParams(value, fullKey) // 再帰処理
    }
    if (value === undefined || value === null) {
      return [] // undefined や null は無視
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`
  })

  return params.filter((param) => param !== "").join("&")
}

export const updateQueryParams = (values: Partial<CalculationSchema>) => {
  const {
    applicationId,
    userId,
    userName,
    storeId,
    storeName,
    adPrice,
    isRecipient,
    nop,
    scheduledDealAt,
    paymentMethod,
    applicatedAt,
    strategy,
    exCustomerTransferFeeRate,
    consumptionTaxRate,
    maxAdvancePayment,
    initialCost,
    downPayment,
    rent,
    customerTransferFeeRate,
    totalReimbursement,
    customerTransferFee,
    monthlyTransferCount,
    exDiscountedCustomerTransferFeeRate,
    customerTransferFeeRateResult,
    totalReimbursementResult,
    selfPaymentResult,
    customerTransferFeeResult,
    remittanceResult,
    exCustomerTransferFeeRateResult,
  } = values

  const valuesObject = {
    meta: {
      applicationId,
      userId,
      userName,
      storeId,
      storeName,
      adPrice,
      isRecipient,
      nop,
      strategy,
      paymentMethod,
      scheduledDealAt,
      applicatedAt,
    },
    calc: {
      customerTransferFeeRate: {
        result: customerTransferFeeRateResult,
        params: {
          exCustomerTransferFeeRate,
          consumptionTaxRate,
          exDiscountedCustomerTransferFeeRate,
        },
      },
      totalReimbursement: {
        result: totalReimbursementResult,
        params: {
          maxAdvancePayment,
          initialCost,
          downPayment,
        },
      },
      selfPayment: {
        result: selfPaymentResult,
        params: {
          initialCost,
          maxAdvancePayment,
          downPayment,
        },
      },
      customerTransferFee: {
        result: customerTransferFeeResult,
        params: {
          rent,
          customerTransferFeeRate,
        },
      },
      remittance: {
        result: remittanceResult,
        params: {
          totalReimbursement,
          customerTransferFee,
        },
      },
      exCustomerTransferFeeRate: {
        result: exCustomerTransferFeeRateResult,
        params: {
          monthlyTransferCount,
        },
      },
    },
  }

  const queryParams = toQueryParams(valuesObject)

  window.history.replaceState(null, "", `?${queryParams}`)
}
